// eslint-disable-next-line @typescript-eslint/no-unused-vars
function noop(...args) {
    //
}

export { noop };
